<template>
    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange">
        <div class="progresswrap">
            <Cprogress :navsub="navsub" :options="c_myoption" v-if="isload && navsub<9"></Cprogress>
            <Clearning :navsub="0" :options="c_myoption" v-if="isload && navsub==9"></Clearning>
        </div>
    </Cmember>
</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'myprogress',
        mixins: [mixinmember],
        components: {
            Cprogress: () => import('@/components/Cprogress'),
            Clearning: () => import('@/components/Clearning')
        },
        data() {
            return {
                curnavkv: 4
            };
        },
        computed: {
            c_options: function () {
                let _options = { 'hasoption': true, 'courselev': 4, 'showcourse': 2, 'haskw': true, 'noteng': 0, 'issch': 0, 'anycourse': true };
                switch (this.navsub) {
                    case 0:
                        _options.schstat = 0;
                        break;
                    case 1:
                        _options.schstat = 1;
                        break;
                    case 2:
                        _options.schstat = 2;
                        break;
                    case 3:
                        _options.schstat = 3;
                        break;
                    case 9:
                        _options.schstat = 0;
                        _options.showcourse = 4;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                switch (this.navsub) {
                    case 0:
                        _myoption.schstat = 0;
                        break;
                    case 1:
                        _myoption.issch = 1;
                        _myoption.schstat = 1;
                        break;
                    case 2:
                        _myoption.issch = 1;
                        _myoption.schstat = 2;
                        break;
                    case 3:
                        _myoption.issch = 0;
                        _myoption.schstat = 3;
                        break;
                    case 9:
                        _myoption.schstat = 0;
                        break;
                }
                return _myoption;
            }
        }
    }
</script>
